import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.NewsListView.heading',
    defaultMessage: 'Aktualności'
  },
  newest: {
    id: 'views.NewsListView.newest',
    defaultMessage: 'NAJNOWSZE'
  },
  similarNews: {
    id: 'views.NewsListView.similarNews',
    defaultMessage: 'PODOBNE AKTUALNOŚCI'
  },
  button: {
    id: 'views.NewsListView.button',
    defaultMessage: 'Zobacz więcej ...'
  },
  noResults: {
    id: 'views.NewsListView.noResults',
    defaultMessage: 'Brak wyników'
  },
  filterAll: {
    id: 'views.NewsListView.filters.all',
    defaultMessage: 'Wszystkie'
  }
});



// WEBPACK FOOTER //
// ./src/views/News/NewsListView.intl.js